import React from 'react';
import NotificationForm from '../../../components/forms/NotificationForm';

export default function NotificationsCreatePage() {
  return <NotificationForm />;
}
